import { Applicant, Applicants, StartersDispensation } from '@ap/ap-interface-apix-hypotheken-berekening';

export class ApplicantsBuilder {
    mainApplicant: Applicant;
    coApplicant?: Applicant;
    startersDispensation?: StartersDispensation;

    withMainApplicant(mainApplicant: Applicant) {
        this.mainApplicant = mainApplicant;
        return this;
    }

    withCoApplicant(coApplicant: Applicant) {
        this.coApplicant = coApplicant;
        return this;
    }

    withStartersDispensation(startersDispensation: StartersDispensation) {
        this.startersDispensation = startersDispensation;
        return this;
    }

    build(): Applicants {
        return {
            main_applicant: this.mainApplicant,
            co_applicant: this.coApplicant,
            starters_dispensation: this.startersDispensation
        } as Applicants;
    }
}
